<template>
<v-row no-gutters align="center" class="im-result regular">
    <v-col cols="12" md="6">
        <v-row no-gutters align="center">
            <v-col cols="6" class="px-1">
                <div class="d-flex">
                    <v-avatar size="50" class="mx-2">
                        <img v-if="item.avatar" :src="item.avatar">
                        <v-icon v-else size="50">face</v-icon>
                    </v-avatar>
                    <div class="px-1">
                        <div>{{item.first_name}}</div>
                        <div>{{item.last_name}}</div>
                    </div>
                </div>
            </v-col>
            <v-col cols="6" class="px-1">
                <div v-if="item.organization_id">
                    <div class="text-truncate">{{ item.organization.name }}</div>
                    <div>{{ item.organization.type }}</div>
                </div>
                <div v-else class="font-weight-bold">N/A</div>
            </v-col>
        </v-row>
    </v-col>

    <v-col cols="12" md="6">
        <v-row no-gutters align="center" :class="{'pt-2': $vuetify.breakpoint.smAndDown}">
            <v-col cols="12" md="8" class="px-2">
                <div>{{ item.email }}</div>
                <div v-if="item.phone">{{ item.phone }}</div>
            </v-col>
            <v-col md="4" class="px-2" v-if="$vuetify.breakpoint.mdAndUp">
                <div v-if="item.created_at">{{ item.created_at }}</div>
                <div v-else class="font-weight-bold">N/A</div>
            </v-col>
        </v-row>
    </v-col>
</v-row>
</template>

<script>
import defaults from "../utils/PropDefaults.js"

export default {
    props: {
        item: {
            type: Object,
            default: defaults.user_item
        },
    },
    methods: {
        emitClick() {
            this.$emit('click');
        },
    }
}
</script>
